/**
 * The inverse guard, for `/login`.
 *
 * Someone with a live session who navigates to the login screen is sent to the
 * app instead of being asked to prove again what the cookie already proved.
 */
import { Navigate, Outlet } from 'react-router-dom';

import { FullPageLoader } from '../components/FullPageLoader';
import { useAuth } from './auth-context';

export function RedirectIfAuthenticated() {
  const { status } = useAuth();

  if (status === 'loading') {
    return <FullPageLoader label="Checking your session" />;
  }

  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
